import React from 'react';

import { Typography } from '@metarouter-private/mr-mui';

import { useEventDebuggerTableContext } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';
import isActivePayloadCondition from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext/isActivePayloadCondition';

// Advanced search filters the fetched page client-side, so spell out how many of the fetched events
// survived the conditions — otherwise a narrowed table looks like a short pull.
export default function PayloadFilterResultCount() {
  const { events, fetchedEventsCount, payloadConditions } = useEventDebuggerTableContext();
  const hasActiveConditions = payloadConditions.some(isActivePayloadCondition);

  if (!hasActiveConditions) {
    return null;
  }

  return (
    <Typography variant="caption" color="text.secondary" data-test-id="payloadFilterResultCount">
      Showing {events.length} of {fetchedEventsCount} events
    </Typography>
  );
}
